(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-z2-expo-menu"] && !Shopify.designMode) return;
  try {
    function placeBbZ2ExpoMenu(){
  const source=document.getElementById('bb-z2-expo-menu-source');
  if(!source)return;
  const link=source.querySelector('a');
  const desktop=document.querySelector('.nav-bar__linklist');
  const header=document.querySelector('.header');
  const mobile=document.querySelector('#mobile-menu .mobile-menu__nav');
  let placed=false;
  if(desktop){
    if(!desktop.querySelector('.bb-z2-expo-menu')){
      const item=document.createElement('li');
      item.className='nav-bar__item bb-z2-expo-menu-slot';
      item.append(link.cloneNode(true));desktop.prepend(item);
    }
    placed=true;
  }
  if(header){
    if(!header.querySelector('.bb-z2-expo-pocket')){
      const pocket=document.createElement('div');
      pocket.className='bb-z2-expo-pocket'+(desktop?' bb-z2-expo-pocket--inline':'');
      pocket.append(link.cloneNode(true));header.prepend(pocket);
    }
    placed=true;
  }
  if(mobile&&!mobile.querySelector('.bb-z2-expo-menu')){
    const item=document.createElement('li');
    item.className='mobile-menu__nav-item bb-z2-expo-mobile-slot';
    item.append(link.cloneNode(true));mobile.prepend(item);
  }
  source.hidden=placed;
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',placeBbZ2ExpoMenu,{once:true});}else{placeBbZ2ExpoMenu();}
document.addEventListener('shopify:section:load',placeBbZ2ExpoMenu);
  } catch(e) { console.error(e); }
})();

})();
